import { Tag } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const getStatusText = ({ item }) => {
  const { t } = useTranslation();
  return t(item.text);
};
const CustomStatusLabel = ({ dataSource, record, statusKey }) => {
  const { t } = useTranslation();

  const tempOrderStatus = dataSource[record?.[statusKey]];
  if (!tempOrderStatus) return null;

  return record ? (
    <Tag
      color={dataSource[record?.[statusKey]]?.background}
      style={{ borderRadius: 5, padding: '5px 10px', border: 'none' }}
    >
      <div
        style={{
          color: dataSource[record?.[statusKey]]?.color,
        }}
      >
        {t(
          getStatusText({
            // data: record,
            item: tempOrderStatus,
          }),
        )}
      </div>
    </Tag>
  ) : (
    <Tag />
  );
};
CustomStatusLabel.propTypes = {
  record: PropTypes.object,
};

export default CustomStatusLabel;
